import { BrowserModule }              from '@angular/platform-browser';
import { ErrorHandler, NgModule }     from '@angular/core';
import { FormsModule }                from '@angular/forms';
import { HttpModule }                 from '@angular/http';
import { BrowserAnimationsModule }    from '@angular/platform-browser/animations';
import { IonicApp, IonicModule }      from 'ionic-angular';
import { IonicErrorHandler }          from 'ionic-angular';
import { IonicStorageModule }         from '@ionic/storage';
import { SplashScreen }               from '@ionic-native/splash-screen';
import { StatusBar }                  from '@ionic-native/status-bar';

import { ApiService }                 from '../services/api.service';
import { BookService }                from '../services/book.service';
import { CategoryService }            from '../services/category.service';
import { CrawlService }               from '../services/crawl.service';
import { MiscService }                from '../services/misc.service';
import { DraImageDirective }          from '../directives/dra-image.directive';
import { DraInfiniteSwipeDirective }  from '../directives/dra-infinite-swipe.directive';
import { DraMenuComponent }           from '../directives/dra-menu.component';
import { DraScrollToDirective }       from '../directives/dra-scroll-to.directive';
import { SwipeToClose }               from '../directives/swipe-to-close.directive';
import { SwipeVertical }              from '../directives/swipe-vertical.directive';
import { FakeButtonDirective }        from '../directives/fake-button.directive';
import { AddBookComponent }           from '../components/add-book/add-book.component';
import { BooksComponent }             from '../components/books/books.component';
import { RecentBooksComponent }       from '../components/books/recent-books.component';
import { BookmarkedBooksComponent }   from '../components/books/bookmarked-books.component';
import { BookComponent }              from '../components/book/book.component';
import { ReaderComponent }            from '../components/reader/reader.component';
import { AppComponent }               from './app.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    IonicModule.forRoot(AppComponent, {
      platforms: {
        core: {
          mode: 'ios'
        },
        android: {
          mode: 'ios'
        }
      },
    },
      {
        links: [
          {component: BooksComponent, name: 'Books', segment: 'books'},
          {component: RecentBooksComponent, name: 'RecentBooks', segment: 'recent-books'},
          {component: BookmarkedBooksComponent, name: 'BookmarkedBooks', segment: 'bookmarked-books'},
          // {component: BookComponent, name: 'BookReader', segment: 'books/:bookAlias/reader', defaultHistory: ['Books', 'Book']},
          {component: BookComponent, name: 'Book', segment: 'books/:bookAlias', defaultHistory: ['RecentBooks']},
          {component: ReaderComponent, name: 'Reader', segment: 'books/:bookAlias/reader', defaultHistory: ['RecentBooks', 'Book']},
        ]
      }
    ),
    IonicStorageModule.forRoot(),
  ],
  providers: [
    ApiService,
    BookService,
    CategoryService,
    CrawlService,
    MiscService,
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
  ],
  declarations: [
    AppComponent,
    AddBookComponent,
    BooksComponent,
    RecentBooksComponent,
    BookmarkedBooksComponent,
    BookComponent,
    ReaderComponent,
    // ReaderInnerComponent,
    DraImageDirective,
    DraInfiniteSwipeDirective,
    DraMenuComponent,
    DraScrollToDirective,
    SwipeToClose,
    SwipeVertical,
    FakeButtonDirective,
  ],
  entryComponents: [
    AppComponent,
    AddBookComponent,
    BooksComponent,
    RecentBooksComponent,
    BookmarkedBooksComponent,
    BookComponent,
    ReaderComponent,
    // ReaderInnerComponent,
  ],
  bootstrap: [IonicApp],
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts